<template>
    <div class="is-marginless" @click.stop>

            <div v-for="item in sessions" :key="item._id">
                <router-link v-if="item.isArchived"
                    :to="{
                        name: 'session-detail',
                        params: { _id: item._id },
                    }"
                    target="_blank"
                    
                >
                    <nav
                        class="level px-4 py-4 has-border-bottom is-mobile is-radiusless"
                        v-if="item.isArchived"
                    >
                        <div class="level-left">
                            <div class="level-item">
                                <div class="">
                                    <!--<p class="icon">
                                        <span class="icon is-medium">
                                            <i
                                                class="
                                                    mdi
                                                    mdi-18px
                                                    mdi-calendar-month-outline
                                                "
                                            ></i>
                                        </span>
                                    </p>-->
                                    <p class="is-size-6 session-title">
                                        {{ item.title}}
                                    </p>
                                    <p class="is-size-7 session-date">
                                        {{ $options.filters.createdDate(item.created) }}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="level-right">
                            <div class="level-item">
                                <div class="has-text-centered pr-2">
                                    <!--<router-link v-if="item.isArchived"
                                        :to="{
                                            name: 'session-detail',
                                            params: { _id: item._id },
                                        }"
                                        target="_blank"
                                        
                                    >--><p class="icon">
                                        <span class="icon is-medium icon-stats is-clickable">
                                            <img class="" src="@/assets/images/stats.svg" />
                                        </span>
                                    </p>
                                    <!--</router-link>-->
                                </div>
                                <!--<div class="has-text-centered pl-2" v-if="item.project.type=='treasurehunt'">
                                    <p class="icon">
                                        <span class="icon is-medium icon-stats disabled">
                                            <img class="" src="@/assets/images/delete.svg" />
                                        </span>
                                    </p>
                                </div>-->
                                
                                
                                
                                
                            </div>
                        </div>
                    
                    </nav>
                </router-link>
                
            
            </div>

    </div>
    
    
</template>

<script>
import { fetchItems, updateItem } from '@/services/API';
import _ from 'underscore';
import bulmaCollapsible from '@creativebulma/bulma-collapsible';
import moment from 'moment';
import VueQrcode from 'vue-qrcode';
export default {
    components: {
        VueQrcode,
    },
    props: {
        sessions: { type: Array, default: [] },
    },
    data() {
        return { session: {} };
    },
    filters: {
        createdDate(timestamp) {
            return moment(timestamp).format('DD/MM/YYYY');
        },
    },
    computed: {
        project() {
            return this.$store.getters.project;
        },
        editing() {
            // console.log(this.session, this.session._id);
            return this.session._id ? true : false;
        },

        isAdmin() {
            return this.$store.getters.isAdmin;
        },
        
    },
    async mounted() {
        /*let response = await fetchItems(
            `session/mine?project=${this.project._id}`
        ).finally(() => {});
        this.sessions = response.data;*/
        // console.log("sessions",this.sessions);
        /*this.$nextTick(() => {
            const collapsibles = bulmaCollapsible.attach();
        });*/
    },
    methods: {
        getActiveParticipantsNumber(session) {
            let players = _.groupBy(session.scores, (score) => {
                return score.owner.owner;
            });
            let scoresData = _.map(players, (scores, player) => {
                return {
                    name: scores[0].owner.name,
                    owner: scores[0].owner.owner,
                    score: _.reduce(
                        scores,
                        (memo, score) => {
                            return memo + score.points;
                        },
                        0
                    ),
                    time: _.reduce(
                        scores,
                        (memo, score) => {
                            return memo + score.time;
                        },
                        0
                    ),
                };
            });
            return scoresData.length;
        },
        getQuestionsNumber(session) {
            const totalQuestions = _.filter(
                session.context,
                (question) => {
                    return question.type == 'question' || question.answers;
                }
            );
            // console.log('total questions', totalQuestions);
            return totalQuestions.length;
        },
        getCluesNumber(session) {
            const totalClues = _.filter(session.context, (element) => {
                return element.triggers && element.triggers.GO_TO_POINT;
            });
            return totalClues.length;
        },



        isActive(option) {
            if (this.$refs[option]) {
                if (this.$refs[option][0].classList.contains('is-active')) {
                    this.$refs[
                        `${option}-icon`
                    ][0].childNodes[0].classList.remove('fa-caret-up');
                    this.$refs[`${option}-icon`][0].childNodes[0].classList.add(
                        'fa-caret-down'
                    );
                } else {
                    this.$refs[
                        `${option}-icon`
                    ][0].childNodes[0].classList.remove('fa-caret-down');
                    this.$refs[`${option}-icon`][0].childNodes[0].classList.add(
                        'fa-caret-up'
                    );
                }
            }
        },
        shareSessionURL(session) {
            /*if (!this.availability(session)) {
                return '';
            }*/

            return (
                process.env.VUE_APP_SHARE_SESSION_URL +
                session.shortCode +
                '&lang=' +
                this.$i18n.locale
            );
        },
        playType(session) {
            if (!session.configuration.app && !session.configuration.web) {
                return 'ALL';
            } else if (session.configuration.web) {
                return 'WEB';
            } else if (session.configuration.app) {
                return 'APP';
            }

            return 'ALL';
        },
        availability(session) {
            // console.log(session);
            // console.log(moment().format('YYYYMMDDHHmmss'));
            if (session.configuration.availability) {
                let current = moment().format('YYYYMMDDHHmmss');
                let start = moment(session.configuration.startDate).format(
                    'YYYYMMDDHHmmss'
                );
                let end = moment(session.configuration.limitDate).format(
                    'YYYYMMDDHHmmss'
                );
                return current >= start && current <= end;
            }
            return true;
        },
        canEdit(session) {
            return this.isAdmin || this.isOwner(session);
        },
        isOwner(session) {
            return session.owner.owner === this.$store.getters.user.owner;
        },

    },
};
</script>

<style scoped>
.message {
    background-color: transparent;
    border-radius: 0;
    font-size: 1rem;
    margin-bottom: 0;
    font-family: var(--primary-font);
}
.message-header {
    border-radius: 0;
    padding-right: 0;
    background-color: #f4f4f4;
    border-bottom: 1px solid #d2d2d2;
}
.lb-accordion {
    overflow-y: auto;
    max-height: calc(100vh - 13rem);
    overflow-x: hidden;
}
.message
    a:not(.button):not(.lb-button):not(.lb-toolbar-button_images):not(.lb-toolbar-button_video):not(.lb-toolbar-button_files):not(.lb-toolbar-button_audio):not(.lb-toolbar-button_url):not(.lb-toolbar-button_location):not(.lb-toolbar-button_tags):not(.lb-toolbar-button_question):not(.lb-toolbar-button_object):not(.lb-toolbar-button_point):not(.lb-delete-media):not(.lb-answer):not(.lb-multiple-answer):not(.tag):not(.lb-bain-tag-functional):not(.lb-bain-tag-emotional):not(.lb-bain-tag-life-changer):not(.lb-bain-tag-social-impact):not(.lb-role-tag_administrator):not(.lb-role-tag_teacher):not(.lb-role-tag_student):not(.lb-role-tag_coordinator):not(.lb-role-tag_participant):not(.lb-role-tag_facilitator):not(.lb-status-tag_active):not(.lb-status-tag_inactive):not(.lb-status-tag_invited):not(.dropdown-item) {
    text-decoration: none;
}
.message-body.is-collapsible {
    overflow-x: hidden;
}

/*.is-hoverable:hover{
    background-color: var(--eduloc-red);
    cursor: pointer;
    color: #FFFFFF;
}*/
.session-title{
    font-family: var(--primary-font);
    color: black;
}
/*.is-hoverable:hover .session-title{
    color: white;
}*/
.session-date{
    font-family: var(--primary-font);
}
.has-border-bottom{
    border: 1px solid var(--eduloc-grey-light)
}
.icon-stats img{
    height: 20px;
    margin-top: 5px;
}
.icon-stats.disabled img{
    cursor: not-allowed;
    opacity: 0.5;
}
</style>
